var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header_container"
  }, [_c('div', {
    staticClass: "menu-redesign"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/logo_new.svg?v=2"),
      "width": "116",
      "height": "36",
      "alt": "Финсайт"
    }
  })]), _c('c-menu', {
    attrs: {
      "type": "pc"
    }
  }), _c('ul', {
    staticClass: "header-buttons"
  }, [_vm.user === null ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/user.svg")
    }
  })])], 1) : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/user.svg")
    }
  })])], 1)]], 2)], 1)]), _c('div', {
    staticClass: "menu_mobile",
    class: {
      'no-line': _vm.hasHeaderLine
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/logo_new.svg?v=2"),
      "width": "116",
      "height": "36",
      "alt": "Финсайт"
    }
  })]), _c('ul', [_vm.user === null ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/user.svg")
    }
  })])], 1) : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/user.svg")
    }
  })])], 1)]], 2)], 1), _vm.mobHasMenu ? _c('div', {
    staticClass: "mobile"
  }, [_c('c-menu', {
    attrs: {
      "type": "mobile"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }